
export const CHARGE_STATION_SECURITY = [
    {id: 1, value: "none"},
    {id: 2, value: "basic_auth"},
    {id: 3, value: "tls_basic_auth"}
]